<template>
    <div class="login-layout">
        <slot/>
    </div>
</template>